__turbopack_context__.v({
  "facetTitle": "Panel-module-scss-module__h0KIGa__facetTitle",
  "panel": "Panel-module-scss-module__h0KIGa__panel",
});
